
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const NegavidPlayer_pocast_Component = (props) => {



    useEffect(() => {
        setTimeout(() => {
            window.message = ["name", "family", "email", "phone", "#fff", "5"];
        }, 1000); // زمان به میلی‌ثانیه افزوده شده است
    }, []);


    return (

        <div>

            <div className="negavid-audio-stream" style={{position: 'relative', paddingBottom: '56.25%', paddingTop: '25px', height: 0, overflow: 'hidden'}}> <iframe id={String(props.id_video)} style={{border: 'none', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} src={"https://open.negavid.com/stream/audio/embed/code/" + String(props.id_video) } allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" /></div>
        </div>

    );
};

export default NegavidPlayer_pocast_Component;